import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './bk01.png'
import _imports_1 from './bk02.png'
import _imports_2 from './alk1.svg'
import _imports_3 from './bk03.png'


const _withScopeId = n => (_pushScopeId("data-v-1d41b972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_blog press" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case" }, null, -1))
const _hoisted_3 = { class: "mx800 mm40" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h2 mb50",
  id: "font-size"
}, "Maodong Xu: Leading Roxe’s Global Growth Efforts", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l4" }, null, -1))
const _hoisted_6 = { class: "mx800" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mtb40 black-color",
  id: "font-size"
}, [
  /*#__PURE__*/_createTextVNode(" Roxe’s President, Maodong Xu, is an entrepreneur who has dedicated his career to making innovative technologies more accessible to the public, with a focus in recent years on blockchain. Over the course of nearly 25 years, Maodong has established many successful technology businesses in several industries. As a result of his accomplishments, Maodong has built a track record as an admired business leader and strategic thinker. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Maodong’s mission for advancement of technology started when he was young. He was born in a small fishing village in Shandong Province of China at a time when technology was still in its infancy in his country. Maodong went on to earn a degree in Computer Application and Automation and Business Management and also an MBA. His first job out of college was as an engineer at a railroad company where he managed the company’s automation systems. Maodong, however, had a bigger vision, which led him to becoming a technology entrepreneur. This started his journey in forming his own companies focused on developing cutting-edge technologies. Since then, Maodong has never looked back. ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bkimg",
  src: _imports_0
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cc black-color",
  id: "font-size"
}, "Maodong Xu, President of Roxe", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "black-color",
  id: "font-size"
}, " Over the course of his illustrious career, Maodong has found and grown numerous companies all with the same goal - bringing next-generation technologies to the masses. Below is a brief summary of the companies that Maodong has founded and/or led: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bkimg mt40",
  src: _imports_1
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cc black-color",
  id: "font-size"
}, " Wowo, founded by Maodong Xu, was listed on the Nasdaq in 2015 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb30 black-color",
  id: "font-size"
}, " In addition to being a founder of successful technology companies, Maodong is also a skilled inventor. He has obtained numerous patents for his inventions. Below is a select list of patents that Maodong has obtained. ", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"text-decoration":"none"} }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mtb40 black-color",
  id: "font-size"
}, [
  /*#__PURE__*/_createTextVNode(" Given his notable contributions to the technology industry, and to society as a whole, Maodong has received recognition for his endeavors. In 2017, together with Jack Ma, he was awarded as one of the top ten newsmakers in China. The Beijing Government has also recognized Maodong as a special talent for technology innovation. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("In his spare time, Maodong uses his entrepreneurial talents and prowess towards more innovation. He engages in charitable activities in the field of education and has sponsored more than a dozen students at prestigious schools such as Harvard, Tsinghua University and Peking University. In addition, Maodong also served as a donor to multiple academic institutions, including his high school. ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bkimg",
  src: _imports_3
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cc black-color",
  id: "font-size"
}, " Maodong Xu was awarded as one of the top ten newsmakers in China ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb20 black-color",
  id: "font-size"
}, "News:", -1))
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"text-decoration":"none"} }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dr70 mb20",
  id: "font-size"
}, "Share this blog post", -1))
const _hoisted_23 = {
  class: "h3 mt50 mb20",
  id: "font-size"
}
const _hoisted_24 = { class: "grid mb50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Share = _resolveComponent("Share")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Tail = _resolveComponent("Tail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['top', _ctx.bkcolor ? _ctx.bkcolor : ''])
    }, [
      _createVNode(_component_Header, { theme: _ctx.bkcolor }, null, 8, ["theme"])
    ], 2),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Bar)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (item, index) => {
        return (_openBlock(), _createBlock(_component_Link, {
          class: "mt40 black-color",
          desc: item.desc,
          link: item.link,
          title: item.title,
          key: index,
          id: "font-size"
        }, null, 8, ["desc", "link", "title"]))
      }), 128)),
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_two, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "alink",
          key: item.title,
          id: "font-size"
        }, [
          _createElementVNode("a", {
            class: "link-color",
            href: item.link
          }, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1),
            _hoisted_15
          ], 8, _hoisted_14)
        ]))
      }), 128)),
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_three, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "alink",
          key: item.title,
          id: "font-size"
        }, [
          _createElementVNode("a", {
            class: "link-color",
            href: item.link
          }, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1),
            _hoisted_21
          ], 8, _hoisted_20)
        ]))
      }), 128)),
      _hoisted_22,
      _createVNode(_component_Share, { class: "mb50" }),
      _withDirectives(_createElementVNode("div", _hoisted_23, "Read More...", 512), [
        [_vShow, false]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (item, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: "mxx20",
            key: index,
            data: item
          }, null, 8, ["data"]))
        }), 128))
      ], 512), [
        [_vShow, false]
      ])
    ]),
    _createVNode(_component_Tail)
  ]))
}